import { FC, useEffect, useRef } from 'react';
import { useTemporaryClass } from '@src/hooks/useTemporaryClass';
import { useLyftSocket } from '@src/hooks';

type StatusLabelProp = {
  label: string;
  segId: number;
  style?: any;
  className?: string;
  dataTestId?: string;
};

export const StatusLabelPill: FC<StatusLabelProp> = ({
  label,
  style = {},
  className,
  segId,
  dataTestId,
}) => {
  const { flashClassName, triggerClass } = useTemporaryClass(3800);
  const { socketStatus } = useLyftSocket();
  const prevStatusIdRef = useRef<number | undefined>(undefined);
  const statusId = socketStatus?.[segId]?.statusId as number | undefined;

  useEffect(() => {
    if (statusId === undefined) return;
    if (prevStatusIdRef.current !== statusId) {
      triggerClass('status_column_animation');
      prevStatusIdRef.current = statusId;
    }
  }, [statusId, triggerClass]);

  return (
    <span
      data-test-id={`${dataTestId}-status-label-pill`}
      className={`${className} ${flashClassName}`}
      style={{ ...(style || {}) }}
    >
      {label}
    </span>
  );
};
